import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import allAPI from "../../api/api";

const initialState = {};

export const createForm = createAsyncThunk(
  "formBuilder/createForm",
  async (payload) => {
    try {
      const response = await allAPI.formBuilder.createForm(payload);
      if (response.status === 201) {
        return response.data;
      } else {
        throw new Error(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("API call failed:", error);
      throw error;
    }
  }
);

export const createFormMapping = createAsyncThunk(
  "formBuilder/createFormMapping",
  async (payload) => {
    try {
      const response = await allAPI.formBuilder.createFormMapping(payload);
      if (response.status === 201) {
        return response.data;
      } else {
        throw new Error(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("API call failed:", error);
      throw error;
    }
  }
);

export const updateForm = createAsyncThunk(
  "formBuilder/updateForm",
  async (payload) => {
    try {
      const response = await allAPI.formBuilder.updateForm(payload);
      if (response.status === 201) {
        return response.data;
      } else {
        throw new Error(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("API call failed:", error);
      throw error;
    }
  }
);

export const updateFormMapping = createAsyncThunk(
  "formBuilder/updateForm",
  async (payload) => {
    try {
      const response = await allAPI.formBuilder.updateFormMapping(payload);
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("API call failed:", error);
      throw error;
    }
  }
);


export const getFormData = createAsyncThunk(
  "formBuilder/getFormData",
  async (payload) => {
    try {
      const response = await allAPI.formBuilder.getFormData(payload);
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("API call failed:", error);
      throw error;
    }
  }
);

export const getFormDataMapping = createAsyncThunk(
  "formBuilder/getFormMapping",
  async (payload) => {
    try {
      const response = await allAPI.formBuilder.getFormMapping(payload);
      if (response.status === 201) {
        return response.data;
      } else {
        throw new Error(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("API call failed:", error);
      throw error;
    }
  }
);


export const deleteFormDataThunk = createAsyncThunk(
  "formBuilder/deleteFormData",
  async (payload) => {
    try {
      const response = await allAPI.formBuilder.deleteFormData(payload);
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("API call failed:", error);
      throw error;
    }
  }
);


export const deleteFormMapping = createAsyncThunk(
  "formBuilder/deleteFormMapping",
  async (payload) => {
    try {
      const response = await allAPI.formBuilder.deleteFormMapping(payload);
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("API call failed:", error);
      throw error;
    }
  }
);

const formBuilderSlice = createSlice({
  name: "formBuilder",
  initialState,
  reducers: {},
  extraReducers: (builder) => {},
});

export const {} = formBuilderSlice.actions;

export default formBuilderSlice.reducer;
